import React, { useEffect, useState } from 'react';
import {
  AlignLeftOutlined,
  AlignRightOutlined,
  UnorderedListOutlined,
  BarChartOutlined,
  UserOutlined,
  SettingOutlined,
  CaretDownFilled,
  CaretRightFilled,
  BellOutlined,
  FieldTimeOutlined,
} from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Menu, theme, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { setLogout } from '../store/ducks/user/userSlice';
import { LogoutIcon } from '../assets/image/svg';

const { Sider, Content } = Layout;

const AuthLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dataRedux = useSelector((state) => state.user);
  const [selectKeys, setSelectKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    setSelectKeys([location.pathname]);
  }, [location]);

  const handleLogout = async () => {
    dispatch(setLogout());
    navigate('/login');
  };

  const items = [
    {
      key: '/quan-ly-cron-job-root',
      label: <Link to={'/quan-ly-cron-job'}>Quản lý Cron Job</Link>,
      icon: <FieldTimeOutlined className="text-white text-2xl" />,
    },
    {
      key: 'advertisement',
      label: 'Quảng cáo',
      icon: <UnorderedListOutlined className="text-white text-2xl" />,
      children: [
        {
          key: '/quan-ly-chien-dich',
          label: <Link to={'/quan-ly-chien-dich'}>Quản lý chiến dịch quảng cáo</Link>,
        },
        {
          key: '/quan-ly-banner',
          label: <Link to={'/quan-ly-banner'}>Quản lý Banner</Link>,
        },
        {
          key: '/quan-ly-popup',
          label: <Link to={'/quan-ly-popup'}>Quản lý Popup</Link>,
        },
      ],
    },
    {
      key: 'notification',
      label: 'Thông báo',
      icon: <BellOutlined className="text-white text-2xl" />,
      children: [
        {
          key: '/quan-ly-thong-bao',
          label: <Link to={'/quan-ly-thong-bao'}>Quản lý thông báo</Link>,
        },
      ],
    },
    {
      key: 'statistic',
      label: 'Thống kê',
      icon: <BarChartOutlined className="text-white text-2xl" />,
      children: [
        {
          key: '/thong-ke-chien-dich',
          label: <Link to={'/thong-ke-chien-dich'}>Thống kê chiến dịch quảng cáo</Link>,
        },
        {
          key: '/thong-ke-thong-bao',
          label: <Link to={'/thong-ke-thong-bao'}>Thống kê thông báo</Link>,
        },
      ],
    },
    {
      key: 'partner',
      label: 'Đối tác',
      icon: <UserOutlined className="text-white text-2xl" />,
      children: [
        {
          key: '/quan-ly-doi-tac',
          label: <Link to={'/quan-ly-doi-tac'}>Quản lý đối tác</Link>,
        },
      ],
    },
    {
      key: 'system_manager',
      label: 'Quản trị hệ thống',
      icon: <SettingOutlined className="text-white text-2xl" />,
      children: [
        {
          key: '/quan-ly-nguoi-dung',
          label: <Link to={'/quan-ly-nguoi-dung'}>Quản lý người dùng</Link>,
        },
        {
          key: '/quan-ly-nhom-quyen',
          label: <Link to={'/quan-ly-nhom-quyen'}>Quản lý nhóm quyền</Link>,
        },
        {
          key: '/quan-ly-tinh-nang',
          label: <Link to={'/quan-ly-tinh-nang'}>Quản lý tính năng</Link>,
        },
      ],
    },
  ];

  const checkPermissionItems = items
    .map((item) => {
      // Nếu item không có children (menu cấp 1 như Quản lý Cron Job) thì giữ nguyên
      if (!item.children) {
        return item;
      }

      // Nếu có children thì filter theo permission
      const children = item.children.filter(
        (child) =>
          dataRedux?.info.permissions?.some((i) => i.key_menu === child.key) || dataRedux.info.role === 9999
      );

      if (children?.length) {
        return { ...item, children };
      }
      return false;
    })
    .filter((item) => item);

  // Lấy tất cả các key của SubMenu để mở
  useEffect(() => {
    const getSubMenuKeys = (items) => {
      let keys = [];
      for (let item of items) {
        if (item.children) {
          keys.push(item.key);
          keys = [...keys, ...getSubMenuKeys(item.children)];
        }
      }
      return keys;
    };

    setOpenKeys(getSubMenuKeys(checkPermissionItems));
  }, []);

  return (
    <Layout>
      <Sider
        className="fixed top-0 left-0 h-screen overflow-hidden bg-[#075CDD] z-20"
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={256}
        collapsedWidth={80}
      >
        <div className="flex justify-between items-center w-full h-18 px-6 py-4 bg-[#0C2FDD]">
          {!collapsed && <div className="text-2xl text-white font-semibold">LV Advertise</div>}
          <Button
            type="text"
            icon={
              collapsed ? (
                <AlignLeftOutlined className="text-white text-2xl" />
              ) : (
                <AlignRightOutlined className="text-white text-2xl" />
              )
            }
            onClick={() => setCollapsed(!collapsed)}
          />
        </div>
        <Menu
          mode="inline"
          theme="dark"
          inlineCollapsed={collapsed}
          expandIcon={({ isOpen }) => (isOpen ? <CaretDownFilled /> : <CaretRightFilled />)}
          className="bg-[#075CDD] gap-4 overflow-y-auto scrollbar-none"
          selectedKeys={selectKeys}
          items={checkPermissionItems}
          openKeys={openKeys}
          onOpenChange={setOpenKeys}
        />
        <div
          onClick={() => handleLogout()}
          className="absolute bottom-0 left-0 flex justify-start items-center w-full h-12 px-6 py-3 bg-[#0C2FDD] z-10 hover:cursor-pointer border border-[#075CDD] hover:border-white gap-2"
        >
          <LogoutIcon color="white" />
          {!collapsed && <div className="text-white flex item-center text-sm font-semibold">Đăng xuất</div>}
        </div>
      </Sider>
      <Layout className={`min-h-screen ${!collapsed ? 'ml-64' : 'ml-20'}`}>
        <div className="sticky top-0 z-10 bg-white h-16">
          <div className="flex flex-row w-full h-full justify-between items-center px-6">
            <div className="flex flex-col h-full justify-between items-start py-2">
              <div className="text-[#3699FF] text-base font-semibold">{moment().format('DD/MM/YYYY')}</div>
              <div className="text-[#181C32] text-sm font-semibold">{moment().format('dddd')}</div>
            </div>
            <div className="w-full flex justify-end items-center">
              <Dropdown
                menu={{
                  items: [
                    // {
                    //   key: '0',
                    //   icon: <i className="fa-light fa-user-gear"></i>,
                    //   label: (
                    //     <Link to={'/account-info'} className={'whitespace-nowrap'}>
                    //       Thông tin tài khoản
                    //     </Link>
                    //   ),
                    // },
                    {
                      key: '1',
                      icon: <LogoutIcon color="black" />,
                      label: <span className="ml-3">Đăng xuất</span>,
                      onClick: () => handleLogout(),
                    },
                  ],
                }}
                placement="bottom"
                overlayClassName={'shadow'}
              >
                <div className={'cursor-pointer inline-flex items-center gap-1'}>
                  <Typography.Text className={' font-medium mr-1 text-base inline-flex items-center'}>
                    {`${dataRedux?.info?.username}`}
                  </Typography.Text>
                  <Avatar src={dataRedux.info.avatar} icon={<UserOutlined />} size={40} />
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
        <Content className="mx-6 my-4 p-6 min-h-72 bg-white rounded-md">{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AuthLayout;
